module.exports = __webpack_public_path__ + "static/media/30.27d02150.jpg";